import * as React from "react";
import { Link } from "react-router-dom";
import { DeveloperRoutes } from "src/common/developers";

type AllProps = {
  active_path?: string;
}

function DeveloperUserNavigation(props: AllProps) {  
  const { active_path } = props;

  return <>
    <Link title="Go to Workflow" to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.workflow_route}`}
      className={active_path === DeveloperRoutes.workflow_route ? " active" : ""}>
      <span className="show-desktop">Workflow</span>
    </Link>
    <Link title="Go to UI Guide" to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}`}
      className={active_path === DeveloperRoutes.ui_guide_route ? " active" : ""}>
      <span className="show-desktop">UI Guide</span>
    </Link>
    <Link title="Go to Sandbox" to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.sandbox_route}`}
      className={active_path === DeveloperRoutes.sandbox_route ? " active" : ""}>
      <span className="show-desktop">Sandbox</span>
    </Link>
    <Link title="Go to Diagnostics" to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.diagnostics}`}
      className={active_path === DeveloperRoutes.diagnostics ? " active" : ""}>
      <span className="show-desktop">Diagnostics</span>
    </Link>
  </>;
}

export default React.memo(DeveloperUserNavigation);
